import { toast } from 'react-toastify';
import api from '../../api';
import { LogsProps } from './types';

export async function createLogRequest(log: LogsProps) {
  try {
    const response = await api().post(`/app-logs`, {
      ...log,
    });

    return response;
  } catch (err: any) {
    toast.error(err.response.data.message);
    console.log(err);

    return null;
  }
}

export async function getLogsByCompanyId(
  companyId: string,
  userId: string,
  search: string,
  name: string,
  local: string,
  action: string,
  date: string,
  page: string,
  size: string,
) {
  try {
    const response = await api().get(`/app-logs/${companyId}`, {
      params: {
        name,
        search,
        local,
        action,
        date,
        page,
        size,
      },
      headers: {
        userId,
      },
    });

    return response;
  } catch (err) {
    console.log(err);

    return null;
  }
}
